import React from "react";
import { connect } from "react-redux";
import { practitionerInfo, clearPractitionerInfo } from "../../actions/auth";

// Semantic UI Components
import { Loader, Card, Icon } from "semantic-ui-react";
import axios from "axios";

class ProfileCard extends React.Component {
  getInfo = data => {
    axios.post("/api/practitioners/practitionerInfo", { data }).then(resp => {
      this.props.practitionerInfo(resp.data);
      this.props.showEditForm();
    });
  };

  render() {
    const {
      names,
      lastnames,
      practitioner_id,
      approved,
      entityUser
    } = this.props;

    return (
      <Card fluid={true}>
        <Loader active={!practitioner_id} />
        <Card.Content>
          <Card.Header>
            {names} {lastnames}
          </Card.Header>
          <Card.Meta>
            <strong>
              {practitioner_id ? "ID: " : ""}
              {practitioner_id}
            </strong>
          </Card.Meta>
          {approved === 1 && !entityUser ? (
            <Card.Content extra>
              <a onClick={() => this.getInfo(practitioner_id)}>
                <Icon name="edit" />
                Editar
              </a>
            </Card.Content>
          ) : null}
        </Card.Content>
      </Card>
    );
  }
}

function mapStateToProps(state) {
  return {
    names: state.practitioner.resp.names,
    lastnames: state.practitioner.resp.lastnames,
    practitioner_id: state.practitioner.resp.practitioner_id,
    approved: state.practitioner.resp.approved,
    entityUser: state.practitioner.resp.entityUser
  };
}
export default connect(mapStateToProps, {
  practitionerInfo,
  clearPractitionerInfo
})(ProfileCard);
